import React, { FunctionComponent } from "react";
import Welcome from "./welcome/welcome";
import Browse from "./browse/browse";
import useSelection from "@/use-selection";
import Detail from "./detail/detail";

const Page: FunctionComponent<PageLayoutProps> = ({
  hasGeolocated,
  setHasGeolocated,
}) => {
  const { selection } = useSelection();

  return (
    <div
      id="layout"
      className="tw-absolute tw-top-0 tw-left-0 tw-h-full tw-flex tw-z-50 tw-w-full tw-p-6 tw-pointer-events-none"
    >
      {hasGeolocated === false && (
        <Welcome onViewport={() => setHasGeolocated(true)} />
      )}
      {hasGeolocated === true && selection == null && (
        <Browse onShowGeolocate={() => setHasGeolocated(false)} />
      )}
      {selection != null && <Detail />}
    </div>
  );
};

export type PageLayoutProps = {
  hasGeolocated: boolean;
  setHasGeolocated: (value: boolean) => void;
};

export default React.memo(Page);
